import { FC } from 'react';
import { RelayEnvironmentProvider, useLazyLoadQuery } from 'react-relay/hooks';
// @ts-ignore
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router-dom';
import newEnvironment from '../../relay/RelayEnvironment';
import { itemQuery } from './__generated__/itemQuery.graphql';
import { getTranslations } from './localization';

const ItemContent: FC<{ accessToken: string }> = ({ accessToken }) => {
    const copy = getTranslations();
    const { marketplaceOrderDetail } = useLazyLoadQuery<itemQuery>(
        graphql`
          query itemQuery($accessToken: String!) {
            marketplaceOrderDetail: marketplaceOrderDetailByAccessToken(
              accessToken: $accessToken
            ) {
              designerUrl
            }
          }
        `,
        { accessToken },
    );

    if (!marketplaceOrderDetail) {
        throw new Error(`Invalid access token ${accessToken}`);
    }

    if (!marketplaceOrderDetail.designerUrl) {
        throw new Error('Designer URL not found');
    }

    // Redirect to the designer URL
    window.location.href = marketplaceOrderDetail.designerUrl;

    return (
        <div>{copy.redirectingToDesigner}</div>
    );
};

const Item: FC = () => {
    const { accessToken } = useParams<{ accessToken?: string }>();
    
    if (!accessToken) {
        throw new Error('Missing access token');
    }

    // Create relay environment without auth token
    const relayEnvironment = newEnvironment();

    return (
        <RelayEnvironmentProvider environment={relayEnvironment}>
            <ItemContent accessToken={accessToken} />
        </RelayEnvironmentProvider>
    );
};

export default Item;
